export const notificationInitial = {
  notification: {
    message: "",
    description: "",
    type: "",
    dateTime: "",
  },
};
